/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AuthVisitorUnifiedFormSigninResponseVisitorFromJSON, AuthVisitorUnifiedFormSigninResponseVisitorToJSON } from './AuthVisitorUnifiedFormSigninResponseVisitor';
export function AuthVisitorUnifiedFormSigninResponseFromJSON(json) {
    return AuthVisitorUnifiedFormSigninResponseFromJSONTyped(json, false);
}
export function AuthVisitorUnifiedFormSigninResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        visitor: !exists(json, 'visitor') ? undefined : AuthVisitorUnifiedFormSigninResponseVisitorFromJSON(json['visitor'])
    };
}
export function AuthVisitorUnifiedFormSigninResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        visitor: AuthVisitorUnifiedFormSigninResponseVisitorToJSON(value.visitor)
    };
}
